const initialState = [
    // branch-1
    {
        id: 'slot-1-01',
        options: ['DE', 'E', 'BIO', 'CH', 'PH', 'M']
    }, {
        id: 'slot-1-02',
        options: ['DE', 'E', 'BIO', 'CH', 'PH', 'M']
    }, {
        id: 'slot-1-03', 
        options: ['EK', 'GE', 'SK', 'SP']
    }, {
        id: 'slot-1-04',
        options: ['ge/ek', 'sk/ek', 'ge/sk']
    }, {
        id: 'slot-1-05',
        options: ['d', 'e', 'f', 'bio', 'ch', 'ph', 'm']
    }, {
        id: 'slot-1-06',
        options: ['d', 'e', 'f', 'bio', 'ch', 'ph', 'm']
    }, {
        id: 'slot-1-07',
        options: ['f', 'l(5)', 'bio', 'ch', 'ph', 'inf']
    }, {
        id: 'slot-1-08',
        options: ['er', 'kr', 'eth']
    }, {
        id: 'slot-1-09',
        options: ['bk', 'mu', 'ds']
    }, {
        id: 'slot-1-10',
        options: ['sp']
    }, 
    // branch-2
    {
        id: 'slot-2-01',
        options: ['DE', 'E', 'BIO', 'CH', 'PH', 'M']
    }, {
        id: 'slot-2-02',
        options: ['DE', 'E', 'BIO', 'CH', 'PH', 'M']
    }, {
        id: 'slot-2-03', 
        options: ['EK', 'GE', 'SK', 'SP']
    }, {
        id: 'slot-2-04',
        options: ['ge/ek', 'sk/ek', 'ge/sk']
    }, {
        id: 'slot-2-05',
        options: ['d', 'e', 'bio', 'ch', 'ph', 'm']
    }, {
        id: 'slot-2-06',
        options: ['d', 'e', 'bio', 'ch', 'ph', 'm']
    }, {
        id: 'slot-2-07',
        options: ['f-n', 'l-n']
    }, {
        id: 'slot-2-08',
        options: ['er', 'kr', 'eth']
    }, {
        id: 'slot-2-09',
        options: ['bk', 'mu', 'ds', 'inf']
    }, {
        id: 'slot-2-10',
        options: ['sp']
    }
]; 

/*
 * Reducer to represent the branches
 *
 */
const slots = (state = initialState, action) => {
    return state;
};

export default slots;